module.exports = __webpack_public_path__ + "img/recognition.8318faa0.jpg";